import type { ReactNode } from 'react';

const VARIANT_COUNT = 12;

function buildDots(variant: number) {
  const dots: { cx: number; cy: number; r: number }[] = [];
  for (let row = 0; row < 3; row++) {
    for (let col = 0; col < 4; col++) {
      const idx = row * 4 + col;
      dots.push({
        cx: 5 + col * 5,
        cy: 7 + row * 5,
        r: idx === variant ? 1.8 : 1.1,
      });
    }
  }
  return dots;
}

const WALLET_AVATARS = Array.from({ length: VARIANT_COUNT }, (_, variant) =>
  buildDots(variant),
);

function hashToIndex(key: string, max: number): number {
  if (!key) return 0;
  let h = 0;
  for (let i = 0; i < key.length; i++) {
    h = (h * 31 + key.charCodeAt(i)) | 0;
  }
  return Math.abs(h) % max;
}

export interface WalletGlyphProps {
  readonly seed?: string | number;
  readonly size?: number;
  readonly className?: string;
}

export function WalletGlyph({
  seed = '',
  size = 36,
  className = '',
}: WalletGlyphProps): ReactNode {
  const idx =
    typeof seed === 'number'
      ? Math.abs(seed) % VARIANT_COUNT
      : hashToIndex(seed, VARIANT_COUNT);
  const dots = WALLET_AVATARS[idx] ?? WALLET_AVATARS[0]!;
  const inner = Math.round(size * 0.62);
  return (
    <div
      className={[
        'grid place-items-center rounded-[10px] bg-surface-2 text-text-primary',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
      style={{ width: size, height: size }}
    >
      <svg
        width={inner}
        height={inner}
        viewBox="0 0 24 24"
        aria-hidden
        className="block"
      >
        {dots.map((d, i) => (
          <circle key={i} cx={d.cx} cy={d.cy} r={d.r} fill="currentColor" />
        ))}
      </svg>
    </div>
  );
}
